const shuffleArray = array => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = ~~(Math.random() * (i + 1));

    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
};

const generatePassword = passwordLength => {
  const numberChars = '0123456789';
  const upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowerChars = 'abcdefghiklmnopqrstuvwxyz';
  const specialChars = '!@#$%&*';
  const allChars = `${numberChars}${upperChars}${lowerChars}${specialChars}`;

  let randPasswordArray = Array(passwordLength);
  randPasswordArray[0] = numberChars;
  randPasswordArray[1] = upperChars;
  randPasswordArray[2] = lowerChars;
  randPasswordArray[3] = specialChars;
  randPasswordArray = randPasswordArray.fill(allChars, 4);

  return shuffleArray(randPasswordArray.map(x => x[~~(Math.random() * x.length)])).join('');
};

export default generatePassword;
